import React from 'react';
import styled from 'styled-components';

import Chip from '../../../CoreWrappers/Chip';

const ChipDrydock = () => {
	const renderDefault = ({variant = 'default', disabled = false, active = false}) => {
		const props = {
			variant,
			disabled
		};

		let text = variant;
		if (active === true) text = text + ' -A';
		if (disabled === true) text = text + ' -D';

		if (active) props.className = 'motif-chip-active';

		return <Chip {...props}>{text}</Chip>;
	};

	const renderOutlined = ({variant = 'default', disabled = false, active = false}) => {
		const props = {
			type: 'outlined',
			variant,
			disabled
		};

		let text = variant + ' -O';
		if (active === true) text = text + ' -A';
		if (disabled === true) text = text + ' -D';

		if (active) props.className = 'motif-chip-active';

		return <Chip {...props}>{`${variant} outlined`}</Chip>;
	};

	const defaultVariants = ['default', 'success', 'warning', 'error', 'monochrome-light'];
	const customVariants = ['blue', 'red', 'orange', 'green', 'purple', 'teal'];

	const mapGroup = (variant) => (
		<>
			{renderDefault({variant})}
			{renderDefault({variant, active: true})}
			{renderDefault({variant, disabled: true})}
			{renderOutlined({variant})}
			{renderOutlined({variant, active: true})}
			{renderOutlined({variant, disabled: true})}
		</>
	);

	return (
		<StyledChipDrydock className="chip-drydock">
			{defaultVariants.map(mapGroup)}
			{customVariants.map(mapGroup)}
		</StyledChipDrydock>
	);
};

const StyledChipDrydock = styled.div`
	--gap: 2rem;
	display: grid;
	grid-template-columns: repeat(6, 1fr);
	grid-template-rows: auto;
	flex: 1;
	gap: var(--gap);
	align-self: start;
	grid-column-end: span 4;
`;

export default ChipDrydock;
